class ShopifyCartPopup {
  inFlight = false;
  constructor() {
    this.overlay = null
    this.isInitialized = false
    this.inFlight = false // <--- AÑADIDO
    this.init()
  }

  init() {
    // Crear el popup si no existe
    this.createPopupHTML()
    this.bindEvents()
    this.interceptAddToCart()
    this.isInitialized = true
  }

  createPopupHTML() {
    // Si ya existe, no crear otro
    if (document.getElementById("cart-popup-overlay")) {
      this.overlay = document.getElementById("cart-popup-overlay")
      if (!document.getElementById("cart-toast-host")) {
        const host = document.createElement("div");
        host.id = "cart-toast-host";
        document.body.appendChild(host);
      }
      return
    }

    // Crear el HTML del popup
    const popupHTML = `
            <div id="cart-popup-overlay" class="popup-overlay">
                <div class="popup-container">
                    <div class="popup-header">
                        <h3>¡Producto añadido al carrito!</h3>
                        <button class="close-btn" id="close-popup">&times;</button>
                    </div>
                    
                    <div class="popup-content">
                        <div class="product-info">
                            <div class="product-image">
                                <img id="popup-product-image" src="/placeholder.svg" alt="Producto">
                            </div>
                            <div class="product-details">
                                <h4 id="popup-product-title"></h4>
                                <p class="product-variant" id="popup-product-variant"></p>
                                <div class="product-price">
                                    <span id="popup-product-original-price"></span>
                                    <span class="price" id="popup-product-price"></span>
                                    <span class="quantity">Cantidad: <span id="popup-product-quantity"></span></span>
                                </div>
                                <div class="product-price">
                                <span class="price" id="popup-product-coupons"></span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="cart-summary">
                            <div class="cart-total">
                                <span>Total del carrito: </span>
                                <span class="total-price" id="popup-cart-total"></span>
                            </div>
                            <div class="cart-count">
                                <span id="popup-cart-count"></span> productos en el carrito
                            </div>
                        </div>
                    </div>
                    
                    <div class="popup-actions">
                        <button class="continue-shopping" id="continue-shopping">
                            Seguir comprando
                        </button>
                        <button class="view-cart" id="view-cart">
                            Ver carrito
                        </button>
                        <button class="checkout-btn" id="checkout-btn">
                            Finalizar compra
                        </button>

                        <div class="radio__input newInput" style="margin-top: 0.5rem;margin-bottom: 0.5rem; text-align:center; ">
                          <div class="radio__input newInput" style="display: block;">
                              <input style="margin-top:-5px;" type="checkbox" class="input-radio"  name="attributes[AddToCartPopup]" value="Si" checked >
                              <label for="Privacidad">
                                <b>
                                  He leído y acepto el <a href="https://catfootwear.com.mx/pages/politica-de-privacidad" target="_blank" title="Aviso de Privacidad" style="text-decoration: underline;">
                                  aviso de privacidad.
            
                                  </a>
                                </b>
                              </label>
                          </div>
                        </div>


                    </div> 
                </div>
            </div>
        `

    // Insertar el CSS
    const style = document.createElement("style")
    style.textContent = this.getCSS()
    document.head.appendChild(style)

    // Insertar el HTML
    document.body.insertAdjacentHTML("beforeend", popupHTML)
    this.overlay = document.getElementById("cart-popup-overlay")
  }

  bindEvents() {
    // Cerrar popup
    document.addEventListener("click", (e) => {
      if (e.target.id === "close-popup" || e.target.id === "cart-popup-overlay") {
        this.hidePopup()
      }
    })

    // Continuar comprando
    document.addEventListener("click", (e) => {
      if (e.target.id === "continue-shopping") {
        this.hidePopup()
      }
    })

    // Ver carrito
    document.addEventListener("click", (e) => {
      if (e.target.id === "view-cart") {
        window.location.href = "/cart"
      }
    })

    // Checkout
    document.addEventListener("click", (e) => {
      if (e.target.id === "checkout-btn") {
        window.location.href = "/checkout"
      }
    })

    // Cerrar con ESC
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.hidePopup()
      }
    })
  }

  interceptAddToCart() {
    // 1) SUBMIT — capturamos antes que otros handlers y bloqueamos su ejecución
    document.addEventListener("submit", (e) => {
      const form = e.target;

      if (!form.matches('form[action*="/cart/add"]')) return;

      // Evita dobles envíos (global y por-form)
      if (this.inFlight || form.dataset.adding === "1") {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      e.preventDefault();
      // Bloquea otros listeners (del tema/apps) que también hacen AJAX
      e.stopImmediatePropagation();
      e.stopPropagation();

      // Marca el form como "en proceso"
      form.dataset.adding = "1";

      this.handleAddToCart(form).finally(() => {
        delete form.dataset.adding;
      });
    }, true); // <-- capture=true (MUY IMPORTANTE)

    // 2) CLICK — no hace POST. Solo fuerza el submit para pasar SIEMPRE por arriba.
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".btn-add-to-cart, [data-add-to-cart]");
      if (!btn) return;

      const form = btn.closest("form");
      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      e.preventDefault();
      e.stopPropagation();

      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        // Fallback: dispara un submit "real" que atrapamos en captura
        form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      }
    });
  }

// === TOASTS: pega esto DENTRO de la clase ShopifyCartPopup ===

// Crea host y CSS si no existen (idempotente)
ensureToastInfra() {
  // Host
  if (!document.getElementById("cart-toast-host")) {
    const host = document.createElement("div");
    host.id = "cart-toast-host";
    document.body.appendChild(host);
  }
  // CSS (solo una vez)
  if (!document.getElementById("cart-toast-css")) {
    const css = `
#cart-toast-host{position:fixed;top:16px;right:16px;z-index:10050;display:flex;flex-direction:column;gap:10px;pointer-events:none}
.cart-toast{min-width:260px;max-width:360px;padding:12px 14px;border-radius:10px;font-size:14px;line-height:1.35;box-shadow:0 10px 25px rgba(0,0,0,.12);pointer-events:auto;display:flex;align-items:flex-start;gap:10px;opacity:0;transform:translateY(-8px);transition:opacity .18s ease,transform .18s ease}
.cart-toast.show{opacity:1;transform:translateY(0)}
.cart-toast__icon{font-size:18px;line-height:1;margin-top:2px}
.cart-toast__msg{flex:1}
.cart-toast__close{background:transparent;border:0;cursor:pointer;font-size:16px;line-height:1;opacity:.7}
.cart-toast__close:hover{opacity:1}
.cart-toast--error{background:#FEE2E2;color:#7F1D1D;border:1px solid #FCA5A5}
.cart-toast--success{background:#ECFDF5;color:#064E3B;border:1px solid #6EE7B7}
@media (max-width:480px){#cart-toast-host{top:auto;right:0;left:0;bottom:16px;align-items:center}.cart-toast{width:calc(100% - 32px);max-width:480px}}
    `;
    const style = document.createElement("style");
    style.id = "cart-toast-css";
    style.textContent = css;
    document.head.appendChild(style);
  }
}

showToast(message, variant = "error", { duration = 4000 } = {}) {
  this.ensureToastInfra();

  const host = document.getElementById("cart-toast-host");
  if (!host) return;

  const toast = document.createElement("div");
  toast.className = `cart-toast cart-toast--${variant}`;
  toast.setAttribute("role", "alert");
  toast.innerHTML = `
    <span class="cart-toast__icon">${variant === "success" ? "✔️" : "⚠️"}</span>
    <div class="cart-toast__msg">${this.escapeHtml(message || "Ocurrió un error.")}</div>
    <button class="cart-toast__close" aria-label="Cerrar">×</button>
  `;

  toast.querySelector(".cart-toast__close").addEventListener("click", () => this.removeToast(toast));

  host.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add("show"));
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => this.removeToast(toast), duration);
}

removeToast(toast) {
  if (!toast) return;
  toast.classList.remove("show");
  setTimeout(() => toast.remove(), 180);
}

// Utilidad para evitar errores si falta
escapeHtml(str) {
  return String(str).replace(/[&<>"']/g, s => (
    { "&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#039;" }[s]
  ));
}




  // Dentro de tu clase ShopifyCartPopup
async handleAddToCart(form) {
  if (this.inFlight) return; // Evita duplicados
  this.inFlight = true;

  try {
    const formData = new FormData(form);

    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin",
      cache: "no-store"
    });

    if (response.ok) {
      const addedItem = await response.json();
      await this.showPopup(addedItem);
      
      // Llamamos a /cart.js para actualizar el contador
      await this.updateCartCount();

      return true;
    }

    // Manejo del error 422
    if (response.status === 422) {
      let msg = "Tu carrito ya tiene la cantidad máxima de este artículo.";
      try {
        const err = await response.json();
        msg = err?.message || err?.description || msg;
      } catch (_) {}
      this.showToast(msg, "error", { duration: 5000 });
      return false;
    }

    // Otro tipo de errores
    const txt = await response.text().catch(() => "");
    console.error("Error al añadir al carrito", response.status, txt);
    this.showToast("No pudimos añadir el producto. Inténtalo de nuevo.", "error");
    return false;

  } catch (error) {
    console.error("Error:", error);
    this.showToast("Ocurrió un error de conexión. Intenta de nuevo.", "error");
    return false;

  } finally {
    // Liberar el candado
    this.inFlight = false;
  }
}


async updateCartCount() {
  try {
    const cartResponse = await fetch("/cart.js", {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    });
    const cart = await cartResponse.json();

    // Aquí asumimos que tu icono de carrito tiene el ID #cart-count
    const cartCountElement = document.querySelector(".thb-item-count");
    if (cartCountElement) {
      cartCountElement.textContent = cart.item_count;
    }
  } catch (error) {
    console.error("Error al obtener el carrito:", error);
  }
}


  async showPopup(addedItem) {
    try {
      // Obtener información actualizada del carrito
      const cartResponse = await fetch("/cart.js", {
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      });
      const cart = await cartResponse.json();

      // Actualizar el contenido del popup
      this.updatePopupContent(addedItem, cart);

      // Mostrar el popup
      this.overlay.classList.add("show");
      document.body.style.overflow = "hidden";
    } catch (error) {
      console.error("Error al mostrar popup:", error);
    }
  }


  updatePopupContent(addedItem, cart) {
    // Imagen del producto
    const image = document.getElementById("popup-product-image");
    image.src = addedItem?.featured_image?.url || addedItem?.image || "/assets/no-image.png";
    image.alt = addedItem?.product_title || "Producto";

    // Título del producto
    document.getElementById("popup-product-title").textContent = addedItem?.product_title || "";

    // Variante
    const variantText = (addedItem?.variant_title && addedItem.variant_title !== "Default Title")
      ? addedItem.variant_title
      : "";
    document.getElementById("popup-product-variant").textContent = variantText;

    // Precio
    const popupProductPrice = document.getElementById("popup-product-price");
    popupProductPrice.textContent =
      this.formatMoney(addedItem?.final_price ?? addedItem?.price ?? 0);

    // Precio descuento
  //  const discountPrice = (addedItem?.discounted_price < addedItem?.final_price) 
  //   ? "Descuento: " + this.formatMoney(addedItem?.discounted_price ?? 0) 
  //   : '';
    
    // Añadimos el "?" antes de .textContent para evitar errores si el elemento no existe
    const discountElement = document.getElementById("popup-product-price-discount");
    if (discountElement) {
        discountElement.textContent = discountPrice;
    }

    // cupon
    const hasCoupons = addedItem?.discounts?.length > 0;

    // Extraemos título y monto formateado
    const couponsText = hasCoupons 
        ? "Cupón aplicado: " + addedItem.discounts.map(c => `${c.title} (-${this.formatMoney(c.amount)})`).join(", ") 
        : '';

    const couponsElement = document.getElementById("popup-product-coupons");
    if (couponsElement) {
        couponsElement.textContent = couponsText;
    }

// 1. Buscamos ambos elementos en el DOM
const regularPriceElement = document.getElementById("product_price_regular");
const popupOriginalPriceElement = document.getElementById("popup-product-original-price");

if (regularPriceElement && popupOriginalPriceElement) {

    const originalPrice = regularPriceElement.textContent;
    const itemPrice = addedItem?.final_price ?? addedItem?.price ?? 0;
    console.log("original price", originalPrice);
    console.log("discount price", itemPrice);

    // 2. Copiamos el texto (el precio) del elemento original al popup
    // popupOriginalPriceElement.textContent = regularPriceElement.textContent;

    // 3. (Opcional pero recomendado) Comprobamos si hay descuento para decidir si lo tachamos o lo ocultamos
    const hasDiscount = originalPrice > itemPrice;
    
    if (originalPrice > itemPrice) {
      popupOriginalPriceElement.textContent = this.formatMoney(regularPriceElement.textContent);
        // Lo mostramos tachado
        popupOriginalPriceElement.style.textDecoration = "line-through";
        popupOriginalPriceElement.style.color = "#888";
        popupOriginalPriceElement.style.display = "inline";
        popupProductPrice.style.color = "#d60000ff";
    } else {
        // Si no hay descuento, lo ocultamos para que el popup no se vea redundante
        popupOriginalPriceElement.style.display = "none";
        
    }
}

    // Cantidad
    document.getElementById("popup-product-quantity").textContent = addedItem?.quantity ?? 1;

    // Total del carrito
    document.getElementById("popup-cart-total").textContent = this.formatMoney(cart?.total_price ?? 0);

    // Cantidad de productos en el carrito
    document.getElementById("popup-cart-count").textContent = cart?.item_count ?? 0;
  }


  hidePopup() {
    if (this.overlay) {
      this.overlay.classList.remove("show")
      document.body.style.overflow = ""
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
    }).format(cents / 100)
  }

  getCSS() {
    return `
              /* === Toasts globales (fuera del popup) === */
              #cart-toast-host {
                position: fixed;
                top: 16px;
                right: 16px;
                z-index: 10050; /* por encima del overlay */
                display: flex;
                flex-direction: column;
                gap: 10px;
                pointer-events: none; /* no bloquea clicks del sitio */
              }

              .cart-toast {
                min-width: 260px;
                max-width: 360px;
                padding: 12px 14px;
                border-radius: 10px;
                font-size: 14px;
                line-height: 1.35;
                box-shadow: 0 10px 25px rgba(0,0,0,.12);
                pointer-events: auto; /* sí deja cerrar el propio toast */
                display: flex;
                align-items: flex-start;
                gap: 10px;
                opacity: 0;
                transform: translateY(-8px);
                transition: opacity .18s ease, transform .18s ease;
              }

              .cart-toast.show {
                opacity: 1;
                transform: translateY(0);
              }

              .cart-toast__icon { font-size: 18px; line-height: 1; margin-top: 2px; }
              .cart-toast__msg { flex: 1; }
              .cart-toast__close {
                background: transparent; border: 0; cursor: pointer; font-size: 16px; line-height: 1;
                opacity: .7;
              }
              .cart-toast__close:hover { opacity: 1; }

              /* Variantes */
              .cart-toast--error {
                background: #FEE2E2;
                color: #7F1D1D;
                border: 1px solid #FCA5A5;
              }
              .cart-toast--success {
                background: #ECFDF5;
                color: #064E3B;
                border: 1px solid #6EE7B7;
              }

              /* Responsivo: en móvil, abajo centrado */
              @media (max-width: 480px) {
                #cart-toast-host {
                  top: auto; right: 0; left: 0; bottom: 16px;
                  align-items: center;
                }
                .cart-toast { width: calc(100% - 32px); max-width: 480px; }
              }

            .popup-overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.6);
                display: none;
                justify-content: center;
                align-items: center;
                z-index: 10000;
                opacity: 0;
                transition: opacity 0.3s ease;
            }

            .popup-overlay.show {
                display: flex;
                opacity: 1;
            }

            .popup-container {
                background: white;
                border-radius: 12px;
                max-width: 500px;
                width: 90%;
                max-height: 90vh;
                overflow-y: auto;
                box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                transform: scale(0.8);
                transition: transform 0.3s ease;
            }

            .popup-overlay.show .popup-container {
                transform: scale(1);
            }

            .popup-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 20px 24px 16px;
                border-bottom: 1px solid #e5e5e5;
            }

            .popup-header h3 {
                margin: 0;
                color: #2d3748;
                font-size: 18px;
                font-weight: 600;
            }

            .close-btn {
                background: none;
                border: none;
                font-size: 24px;
                cursor: pointer;
                color: #718096;
                padding: 0;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: background-color 0.2s ease;
            }

            .close-btn:hover {
                background-color: #f7fafc;
                color: #2d3748;
            }

            .popup-content {
                padding: 24px;
            }

            .product-info {
                display: flex;
                gap: 16px;
                margin-bottom: 24px;
            }

            .product-image img {
                width: 80px;
                height: 80px;
                object-fit: cover;
                border-radius: 8px;
                border: 1px solid #e5e5e5;
            }

            .product-details h4 {
                margin: 0 0 8px 0;
                color: #2d3748;
                font-size: 16px;
                font-weight: 600;
                line-height: 1.4;
            }

            .product-variant {
                margin: 0 0 12px 0;
                color: #718096;
                font-size: 14px;
            }

            .product-price {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                gap: 8px;
            }

            .price {
                font-weight: 600;
                color: #2d3748;
                font-size: 16px;
            }

            .quantity {
                color: #718096;
                font-size: 14px;
            }

            .cart-summary {
                background-color: #f7fafc;
                padding: 16px;
                border-radius: 8px;
                margin-bottom: 24px;
            }

            .cart-total {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 8px;
            }

            .total-price {
                font-weight: 600;
                color: #2d3748;
                font-size: 18px;
            }

            .cart-count {
                color: #718096;
                font-size: 14px;
            }

            .popup-actions {
                display: flex;
                flex-direction: column;
                gap: 12px;
                padding: 0 24px 24px;
            }

            .popup-actions button {
                padding: 12px 24px;
                border-radius: 8px;
                font-size: 14px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.2s ease;
                border: none;
            }

            .continue-shopping {
                background-color: #f7fafc;
                color: #4a5568;
                border: 1px solid #e2e8f0;
            }

            .continue-shopping:hover {
                background-color: #edf2f7;
            }

            .view-cart {
                background-color: #4299e1;
                color: white;
            }

            .view-cart:hover {
                background-color: #3182ce;
            }

            .checkout-btn {
                background-color: #48bb78;
                color: white;
            }

            .checkout-btn:hover {
                background-color: #38a169;
            }

            @media (max-width: 480px) {
                .popup-container {
                    width: 95%;
                    margin: 20px;
                }
                
                .product-info {
                    flex-direction: column;
                    text-align: center;
                }
                
                .product-price {
                    justify-content: center;
                    text-align: center;
                }
            }
        `
  }
}

// Inicializar el popup cuando el DOM esté listo
(function initCartPopupOnce() {
  if (window.__cartPopupLoaded) return;
  window.__cartPopupLoaded = true;

  const start = () => new ShopifyCartPopup();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();